import { format, parseISO } from 'date-fns';
import { nl } from 'date-fns/locale';
import { t } from '../../i18n/nl.js';

// Labels + datumformattering voor FactuurDocument.jsx, hier apart gehouden
// zodat dat component zelf taalneutraal blijft en ongewijzigd hergebruikt
// kan worden door de server-side (Deno) PDF-generatie in
// supabase/functions/_shared/invoice-email.ts. De Deno-tegenhanger
// (supabase/functions/_shared/invoicePdfLabels.ts) bevat dezelfde waarden
// als losstaande, hardcoded strings (Deno heeft geen toegang tot de
// i18next-stack) — dit is een BEWUSTE duplicatie die NIET automatisch
// synchroon blijft: bij het wijzigen/toevoegen van een pdf.*-sleutel in
// nl.json altijd ook supabase/functions/_shared/invoicePdfLabels.ts
// handmatig bijwerken, anders lopen de handmatige en automatische
// factuur-PDF weer stilzwijgend uit elkaar.
export function getFactuurPdfLabels() {
  return {
    factuur: t('pdf.factuur'),
    btwnr: t('pdf.btwnr'),
    kvk: t('pdf.kvk'),
    betaalgegevens: t('pdf.betaalgegevens'),
    teBetalen: t('pdf.teBetalen'),
    voor: t('pdf.voor'),
    naarIban: t('pdf.naarIban'),
    opNaamVan: t('pdf.opNaamVan'),
    omschrijvingBet: t('pdf.omschrijvingBet'),
    factuurdetails: t('pdf.factuurdetails'),
    factuurnummer: t('pdf.factuurnummer'),
    factuurdatumLabel: t('pdf.factuurdatumLabel'),
    betalingstermijn: t('pdf.betalingstermijn'),
    dagen: t('pdf.dagen'),
    klantnummer: t('pdf.klantnummer'),
    omschrijving: t('pdf.omschrijving'),
    aantal: t('pdf.aantal'),
    stukprijs: t('pdf.stukprijs'),
    colBtwPct: t('pdf.colBtwPct'),
    colExcl: t('pdf.colExcl'),
    colBtw: t('pdf.colBtw'),
    colIncl: t('pdf.colIncl'),
    geenRegeldetails: t('pdf.geenRegeldetails'),
    btwSpecificatie: t('pdf.btwSpecificatie'),
    btwPercent: t('pdf.btwPercent'),
    grondslag: t('pdf.grondslag'),
    bedrag: t('pdf.bedrag'),
    totaalExclBtw: t('pdf.totaalExclBtw'),
    btw: t('pdf.btw'),
    totaalInclBtw: t('pdf.totaalInclBtw'),
    pagina: t('pdf.pagina'),
    van2: t('pdf.van2'),
  };
}

export function getFactuurStatusLabels() {
  return {
    sent: t('status.sent'),
    paid: t('status.paid'),
  };
}

export function pdfFmtDate(str) {
  if (!str) return '—';
  try { return format(parseISO(str), 'd MMMM yyyy', { locale: nl }); }
  catch { return str; }
}
